import {call, put} from "redux-saga/effects";
import {getAuditTrailAPI} from "../../components/dataEntryDetails/test/DataEntry.APIs";
import {
    API_FETCHING,
    API_INITIAL,
    isSuccessStatusCode,
    ReduxApiStatus
} from "../constants/ApiConstants";
import AuditData from "../../models/auditData";

const defaultState: readOnlyState = {
    getAuditTrailStatus: API_INITIAL,
    auditTrail: [] as AuditData[],
    apiErrorArray: [] as ErrorAPIObj[],
} as const

interface readOnlyState {
    getAuditTrailStatus: ReduxApiStatus,
    auditTrail: Array<AuditData>,
    apiErrorArray: Array<ErrorAPIObj>,
}

export const ReadOnlyTransactionActionConstants = {
    getReadOnlyAuditTrailRequest: "GET_READ_ONLY_AUDIT_TRAIL_REQUEST",
    getReadOnlyAuditTrailResponse: "GET_READ_ONLY_AUDIT_TRAIL_RESPONSE",
    API_ERROR_STATE: "API_ERROR_STATE"
} as const

interface ErrorAPIObj {
    status: string,
    statusText: string,
    responseURL: string,
    messages: Array<string>,
    code: string,
    message: string,
    id: number,
    showAlert: boolean
}
    

export const readOnlyTransactionState = (state = defaultState, action: any):readOnlyState => {
    switch (action.type) {
        case ReadOnlyTransactionActionConstants.API_ERROR_STATE:
            if (action.data) {
                let tempApiErrorArray: any = [...state.apiErrorArray]

                let dataObj: ErrorAPIObj = {
                    code: "",
                    id: 0,
                    message: "",
                    messages: [],
                    showAlert: false,
                    status: action.data ? action.data.status : '',
                    statusText: action.data ? action.data.statusText : '',
                    responseURL: action.data ? action.data.request?.responseURL : ''
                }

                if (Array.isArray(action.data?.data)){
                    dataObj.messages = action.data.data.map(d => ({ code: d.code, message: d.message }));
                }else{
                    dataObj.code = action.data ? action.data.data?.code : '';
                    dataObj.message = action.data ? action.data.data?.message : ''
                }

                dataObj.id = tempApiErrorArray.length;
                dataObj.showAlert = true;
                tempApiErrorArray.push(dataObj);

                return {
                    ...state,
                    apiErrorArray: tempApiErrorArray,
                }
            } else {
                return state
            }
        case ReadOnlyTransactionActionConstants.getReadOnlyAuditTrailRequest:
            return {
                ...state,
             
                getAuditTrailStatus: API_FETCHING
            }
        case ReadOnlyTransactionActionConstants.getReadOnlyAuditTrailResponse:
            return {
                ...state,
                auditTrail: action.data.map(audit => ({
                    ...audit,
                    lastUpdate: new Date(audit.lastUpdate),
                    createdDate: new Date(audit.createdDate),
                })),
                getAuditTrailStatus: API_INITIAL
            }
        default:
            return state
    }
}

export const getReadOnlyAuditTrailRequest = (transactionId: string) => {
    return {
        type: ReadOnlyTransactionActionConstants.getReadOnlyAuditTrailRequest,
        data: { transactionId }
    };
}

export function* getReadOnlyAuditTrailSaga(action: { transactionId: string }) {
    try {
        const response = yield call(getAuditTrailAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: ReadOnlyTransactionActionConstants.getReadOnlyAuditTrailResponse, data: response.data });
        } else {
            yield put({ type: ReadOnlyTransactionActionConstants.API_ERROR_STATE, data: response.data });
        }
    } catch (err) {
        yield put({ type: ReadOnlyTransactionActionConstants.API_ERROR_STATE, data: (err as any).response });
    }
}